// extracted by mini-css-extract-plugin
export var statItem = "_e2-1";
export var statsRow = "_e2-0";